import {Character} from "@/characters/model/Character.ts";
import {formatChallengeRating} from "@/characters/model/ChallengeRating.ts";
import {cn} from "@/lib/utils.ts";
import DetailTitleBlock from "@/components/details/DetailTitleBlock.tsx";

export default function CharacterDetailsHeader({character}: {character: Character}) {
    const identity = [character.size, character.type, character.race, ...(character.classes ?? [])]
        .filter((value): value is string => Boolean(value));
    const movement = [
        character.speeds?.walk && `Laufen ${character.speeds.walk}`,
        character.speeds?.fly && `Fliegen ${character.speeds.fly}`,
        character.speeds?.swim && `Schwimmen ${character.speeds.swim}`,
        character.speeds?.climb && `Klettern ${character.speeds.climb}`,
        character.speeds?.burrow && `Graben ${character.speeds.burrow}`,
    ].filter((value): value is string => Boolean(value));

    return (
        <header className={cn(
            "grid gap-x-10 border-b px-4 @min-[40rem]:grid-cols-[minmax(12rem,max-content)_minmax(0,1fr)]",
            character.hostile
                ? "border-hostile/10 bg-linear-to-r from-hostile-dark/25 to-hostile-dark/15"
                : "border-friendly/10 bg-linear-to-r from-friendly-dark/25 to-friendly-dark/15",
        )}>
            <DetailTitleBlock title={character.name}/>

            <div className="min-w-0 space-y-1.5 py-3 text-xs text-muted-foreground">
                <div className="flex min-w-0 flex-wrap items-center gap-1.5">
                    {identity.map((value, index) =>
                        <span key={`${value}-${index}`} className="rounded-sm bg-surface-overlay/55 px-1.5 py-0.5">
                            {value}
                        </span>)}
                    {character.alignment &&
                        <span className="rounded-sm bg-surface-overlay/55 px-1.5 py-0.5 capitalize">{character.alignment}</span>}
                    <div className="ml-auto flex flex-wrap items-center justify-end gap-x-2">
                        {character.challenge != undefined &&
                            <span>Herausforderungsgrad: {formatChallengeRating(character)}</span>}
                        {character.xp && <span>({character.xp} XP)</span>}
                    </div>
                </div>

                <div className="flex min-w-0 flex-wrap items-center gap-x-4 gap-y-1">
                    {movement.length > 0 &&
                        <div className="flex min-w-0 flex-wrap gap-x-1">
                            <span className="font-semibold text-foreground/80">Bewegung:</span>
                            <span>{movement.join(" · ")}</span>
                        </div>}
                    {character.source && <span className="ml-auto">Quelle: {character.source}</span>}
                </div>
            </div>
        </header>
    );
}
